import React from 'react'
import './styles.css'
import PropTypes from 'prop-types'

const ExpandButton = ({ isExpanded, onClick }) => {
  const label = isExpanded ? 'Hide log items' : 'Show log items'
  const iconClass = isExpanded ? 'fa fa-toggle-on' : 'fa fa-toggle-off'

  return (
    <button
      type="button"
      className="expand-button btn btn-link p-0"
      onClick={onClick}
      aria-label={label}
      title={label}
    >
      <i className={iconClass} aria-hidden="true" />
    </button>
  )
}

ExpandButton.propTypes = {
  isExpanded: PropTypes.bool,
  onClick: PropTypes.func.isRequired
}

ExpandButton.defaultProps = {
  isExpanded: false
}

export default ExpandButton


// WEBPACK FOOTER //
// ./src/containers/pools/details/logs/components/expandButton/index.js